/** @format */

import createMutation from "src/api/create-mutation.js";

export const useCreateUser = createMutation({
  url: "/user",
  method: "POST",
});

export const useUpdateUser = createMutation({
  url: "/user/me",
  method: "PATCH",
});

export const useDeleteUser = createMutation({
  url: "/user/me",
  method: "DELETE",
});

// Subscription
export const useCreateUserSubscription = createMutation({
  url: "/user/subscription",
  method: "POST",
});

export const useUpdateUserSubscriptionMe = createMutation({
  url: "/user/me/subscription",
  method: "PATCH",
});

export const useDeleteUserSubscriptionMe = createMutation({
  url: "/user/me/subscription",
  method: "DELETE",
});

export const useUpdateUserSubscriptionByID = createMutation({
  url: (subscription_id) => `/user/subscription/${subscription_id}`,
  method: "PATCH",
});

export const useDeleteUserSubscriptionByID = createMutation({
  url: (subscription_id) => `/user/subscription/${subscription_id}`,
  method: "DELETE",
});

// User Plan
export const useCreateUserPlan = createMutation({
  url: "/user/plan",
  method: "POST",
});

export const useUpdateUserPlanByID = createMutation({
  url: (user_plan_id) => `/user/plan/${user_plan_id}`,
  method: "PATCH",
});

export const useDeleteUserPlanByID = createMutation({
  url: (user_plan_id) => `/user/plan/${user_plan_id}`,
  method: "DELETE",
});

// Profile Picture
export const useUploadUserProfilePicture = createMutation({
  url: "/user/profile_picture",
  method: "POST",
});

export const useUpdateUserProfilePicture = createMutation({
  url: "/user/profile_picture",
  method: "PATCH",
});

export const useDeleteUserProfilePicture = createMutation({
  url: "/user/profile_picture",
  method: "DELETE",
});

// Resume
export const useCreateUserResume = createMutation({
  url: "/user/resume",
  method: "POST",
});

export const useUpdateUserResumeByID = createMutation({
  url: (resume_id) => `/user/resume/${resume_id}`,
  method: "PATCH",
});

export const useDeleteUserResumeByID = createMutation({
  url: (resume_id) => `/user/resume/${resume_id}`,
  method: "DELETE",
});

// Skill
export const useCreateUserSkill = createMutation({
  url: "/user/skill",
  method: "POST",
});

export const useUpdateUserSkillByID = createMutation({
  url: (skill_id) => `/user/skill/${skill_id}`,
  method: "PATCH",
});

export const useDeleteUserSkillByID = createMutation({
  url: (skill_id) => `/user/skill/${skill_id}`,
  method: "DELETE",
});

// Education
export const useCreateUserEducation = createMutation({
  url: "/user/education",
  method: "POST",
});

export const useUpdateUserEducation = createMutation({
  url: (education_id) => `/user/education/${education_id}`,
  method: "PATCH",
});

export const useDeleteUserEducation = createMutation({
  url: (education_id) => `/user/education/${education_id}`,
  method: "DELETE",
});

// Experience
export const useCreateUserExperience = createMutation({
  url: "/user/experience",
  method: "POST",
});

export const useUpdateUserExperience = createMutation({
  url: (experience_id) => `/user/experience/${experience_id}`,
  method: "PATCH",
});

export const useDeleteUserExperience = createMutation({
  url: (experience_id) => `/user/experience/${experience_id}`,
  method: "DELETE",
});

// Certificate
export const useCreateUserCertificate = createMutation({
  url: "/user/certificate",
  method: "POST",
});

export const useUpdateUserCertificateByID = createMutation({
  url: (certificate_id) => `/user/certificate/${certificate_id}`,
  method: "PATCH",
});

export const useDeleteUserCertificateByID = createMutation({
  url: (certificate_id) => `/user/certificate/${certificate_id}`,
  method: "DELETE",
});

// export const useCreateFirstUserCertificate = createMutation({
//   url: "/user/certificate/firstcert",
//   method: "POST",
// });
